import { type FC, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { F0Box, F0Button, F0Icon, F0Text } from '@factorialco/f0-react'
import { Marketplace, Present } from '@factorialco/f0-react/icons/app'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import i18n from 'modules/core/lib/i18n'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { useItManagementFeatureAvailability } from 'modules/it_management/hooks/useItManagementFeatureAvailability'

const OrderPlanSubmittedPage: FC = () => {
  const navigate = useNavigate()
  const { company, access } = useCurrentSession()
  const {
    isDeviceCatalogEnabled,
    loading: featureLoading,
    error: featureError,
  } = useItManagementFeatureAvailability()

  const catalogPath = `/device-catalog`

  useEffect(() => {
    track(trackingEvents.itManagement.deviceCatalogEvents.orderPlanSubmitted, {
      company_id: company.id,
      user_id: access.id,
    })
  }, [company.id, access.id])

  return (
    <ResponsivePage.Body
      authorized={isDeviceCatalogEnabled}
      error={featureError}
      loading={featureLoading}
    >
      <F0Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        padding="2xl"
        gap="xl"
        maxWidth="md"
        marginX="auto"
      >
        <F0Icon icon={Present} size="md" color="default" />
        <div style={{ textAlign: 'center' }}>
          <F0Box display="flex" flexDirection="column" gap="sm">
            <F0Text
              variant="label"
              content={i18n.t('it_management.device_catalog.order_plan.submitted_title')}
            />
            <F0Text
              variant="description"
              content={i18n.t('it_management.device_catalog.order_plan.submitted_message')}
            />
          </F0Box>
        </div>
        <F0Box>
          <F0Box
            display="flex"
            flexDirection="row"
            justifyContent="center"
            gap="md"
            flexWrap="wrap"
          >
            <F0Button
              label={i18n.t('it_management.device_catalog.order_plan.return_to_catalog')}
              variant="default"
              size="md"
              icon={Marketplace}
              onClick={() => navigate(catalogPath)}
            />
            <F0Button
              label={i18n.t('it_management.device_catalog.order_plan.view_orders')}
              variant="outline"
              onClick={() => navigate('/device-catalog/orders')}
            />
          </F0Box>
        </F0Box>
      </F0Box>
    </ResponsivePage.Body>
  )
}

export default OrderPlanSubmittedPage
